import { defineMessages } from 'react-intl';

export default defineMessages({
  set_price: {
    id: 'promotion.set_sell_price_to.set_price',
    defaultMessage: 'Set price'
  },
  floor_price: {
    id: 'promotion.set_sell_price_to.floor_price',
    defaultMessage: 'Floor price'
  },
  markdown_price: {
    id: 'promotion.set_sell_price_to.markdown_price',
    defaultMessage: 'Markdown price'
  },
  cost_plus: {
    id: 'promotion.set_sell_price_to.cost_plus',
    defaultMessage: 'Cost plus'
  }
});
